import { styled } from "styled-components";

export const ModelTypeFormWrapper = styled.form`
  background: var(--light);
  padding: 1.5rem 1rem;
  border-radius: 10px;
`;
